import _ from 'lodash';
import {
  Sheet,
  SheetView,
  SelectionOperationType,
  SheetSelection,
  Area,
  SelectionCell,
} from '../../types';
import {
  mergeAreas,
  isEqualAreas,
  getIntersectedArea,
  reduceAreaByIntersection,
  isAreaInsideArea,
} from '../area/area';
import { getNextVisibleRowCol } from './selection';
import { fitCellInViewport } from './viewport';
import { isEqualRanges } from '../area/range';

export function* updateSelectionOnMouseStop(
  sheet: Sheet,
  sheetView: SheetView,
  windowWidth: number,
  windowHeight: number
) {
  const { temporarySelection, selections } = sheetView;

  if (temporarySelection) {
    const { area: activeArea } = selections[selections.length - 1];
    let { area: newArea } = temporarySelection;

    switch (temporarySelection.op) {
      case SelectionOperationType.Extend:
        newArea = mergeAreas(activeArea, newArea);
        break;
      case SelectionOperationType.SelectionMove:
        if (!isEqualAreas(activeArea, newArea)) {
          // yield put(
          //   handleCellOperationsAc({
          //     sheetId: sheet.id,
          //     operationData: {
          //       op: CellOperations.ShiftCells,
          //       sourceArea: activeArea,
          //       destinationArea: newArea,
          //     },
          //   })
          // );
          return {};
          // const { activeCell, colViewport, rowViewport } =
          //   getActiveCellFromArea(
          //     sheet,
          //     newArea,
          //     sheetView,
          //     windowWidth,
          //     windowHeight
          //   );
          // newArea = temporarySelection.area;
          // return { newArea, activeCell, colViewport, rowViewport };
        }
        break;
      case SelectionOperationType.ColMove:
      case SelectionOperationType.RowMove:
        const isCol = temporarySelection.op === SelectionOperationType.ColMove;
        const alias = isCol ? 'ci' : 'ri';
        const destinationRange = {
          start: newArea.start[alias],
          end: newArea.end[alias],
        };
        const sourceRange = {
          start: activeArea.start[alias],
          end: activeArea.end[alias],
        };

        // Call Row | Col Move Operation
        if (!isEqualRanges(sourceRange, destinationRange)) {
          // yield put(
          //   handleCellOperationsAc({
          //     sheetId: sheet.id,
          //     operationData: {
          //       op: CellOperations.Move,
          //       entityType: isCol ? GridEntity.Column : GridEntity.Row,
          //       sourceRange,
          //       destinationRange,
          //     },
          //   })
          // );
        }
        return {};
    }
    return {
      newArea,
    };
  } else {
    if (selections.length < 2) return;

    const sels = _.cloneDeep(selections);
    const activeSelection = sels.pop();
    if (activeSelection) {
      // const { selections, isDuplicate } = removeDuplicateSelections(
      //   sels,
      //   activeSelection
      // );

      // if (isDuplicate) {
      //   const activeArea = _.last(selections)?.area;
      //   if (activeArea) {
      //     const { activeCell, rowViewport, colViewport } =
      //       getActiveCellFromArea(
      //         sheet,
      //         activeArea,
      //         sheetView,
      //         windowWidth,
      //         windowHeight
      //       );
      //     return {
      //       selections,
      //       activeCell,
      //       rowViewport,
      //       colViewport,
      //       // viewport,
      //     };
      //   }
      // }
      // return {
      //   selections,
      // };

      const { isChanged, newSelections } = divideSelections(
        sels,
        activeSelection
      );

      if (isChanged) {
        const activeArea = _.last(newSelections)?.area;
        if (activeArea) {
          const { activeCell, rowViewport, colViewport } =
            getActiveCellFromArea(
              sheet,
              activeArea,
              sheetView,
              windowWidth,
              windowHeight
            );

          return {
            selections: newSelections,
            activeCell,
            rowViewport,
            colViewport,
          };
        }
      }

      // const { updatedSelections, isUniqueArea } = divideSelections(
      //   sheet,
      //   sels,
      //   activeSelection
      // );
      // const activeArea = _.last(updatedSelections)?.area;
      // if (activeArea && !isUniqueArea) {
      // const { activeCell, viewport } = getActiveCellFromArea(
      //   sheet,
      //   activeArea,
      //   sheetView,
      //   windowWidth,
      //   windowHeight
      // );

      //   return {
      //     selections: updatedSelections,
      //     activeCell,
      //     viewport,
      //   };
      // }
      // else return { selections };
    }
  }
}

const getActiveCellFromArea = (
  sheet: Sheet,
  area: Area,
  sheetView: SheetView,
  windowWidth: number,
  windowHeight: number
): Pick<SheetView, 'activeCell'> &
  Partial<Pick<SheetView, 'colViewport' | 'rowViewport'>> => {
  const sheetViewportView = {
    colViewport: sheetView.colViewport,
    rowViewport: sheetView.rowViewport,
    filterResults: sheetView.filterResults,
  };
  const activeCell = getNextVisibleRowCol(
    sheet,
    area.start.ci,
    area.start.ri,
    sheetView.filterResults,
    0
  );
  const updatedViewports = fitCellInViewport(
    sheet,
    activeCell,
    sheetViewportView,
    windowWidth,
    windowHeight
  );

  return {
    activeCell,
    ...updatedViewports,
  };
};

export const removeDuplicateSelections = (
  selections: SheetSelection[],
  newSelection: SheetSelection
) => {
  let isDuplicate = false;
  const newSels: SheetSelection[] = [];
  for (const selection of selections) {
    if (isEqualAreas(selection.area, newSelection.area)) {
      isDuplicate = true;
    } else {
      newSels.push(selection);
    }
  }

  return {
    selections: [...newSels, newSelection],
    isDuplicate,
  };
  // return isDuplicate ? selections : [...selections, newSelection];
};

const divideSelections = (
  selections: SheetSelection[],
  newSelection: SheetSelection
) => {
  const newSelections: SheetSelection[] = [];
  let selectionToPutAtEnd: SheetSelection | undefined;
  let isChanged = false;
  for (const { area, cell } of selections) {
    const newArea = newSelection.area;
    if (isEqualAreas(newArea, area)) {
      selectionToPutAtEnd = { area, cell };
      isChanged = true;
      continue;
    } else {
      const intersection = getIntersectedArea(newArea, area);
      if (intersection) {
        isChanged = true;

        if (isAreaInsideArea(newArea, area)) {
          const reducedAreas = reduceAreaByIntersection(area, intersection);
          reducedAreas.forEach((area) =>
            newSelections.push({
              area,
              cell: SelectionCell.Cell,
            })
          );
        } else if (isAreaInsideArea(area, newArea)) {
          // DO Nothing
        } else {
          const reducedAreas = reduceAreaByIntersection(area, intersection);
          const reducedNewAreas = reduceAreaByIntersection(
            newArea,
            intersection
          );
          reducedAreas.forEach((area) =>
            newSelections.push({
              area,
              cell: SelectionCell.Cell,
            })
          );
          reducedNewAreas.forEach((area) =>
            newSelections.push({
              area,
              cell: SelectionCell.Cell,
            })
          );
          newSelections.push({
            cell: cell,
            area: intersection,
          });
        }

        continue;
      }
    }
    newSelections.push({ area, cell });
  }

  if (selectionToPutAtEnd) newSelections.push(selectionToPutAtEnd);

  return {
    newSelections,
    isChanged,
  };
};

// export const divideSelections = (
//   sheet: Sheet,
//   selections: SheetSelection[],
//   newSelection: SheetSelection
// ) => {
//   let accumulatedSelections: SheetSelection[] = selections;

//   let isUniqueArea = true;
//   accumulatedSelections = accumulatedSelections.reduce(
//     (acc, existingSelection) => {
//       if (isAreaInsideArea(newSelection.area, existingSelection.area)) {
//         const dividedAreas = divideArea(
//           sheet,
//           existingSelection.area,
//           newSelection.area
//         );
//         isUniqueArea = false;
//         return [
//           ...acc,
//           ...dividedAreas.map((area) => ({
//             area,
//             cell: newSelection.cell,
//           })),
//         ];
//       }
//       return [...acc, existingSelection];
//     },
//     [] as SheetSelection[]
//   );

//   if (isUniqueArea) accumulatedSelections.push(newSelection);
//   else if (!accumulatedSelections.length)
//     accumulatedSelections.push(newSelection);

//   return { updatedSelections: accumulatedSelections, isUniqueArea };
// };

// const divideArea = (
//   sheet: Sheet,
//   areaToDivide: Area,
//   areaToSubtract: Area
// ): Area[] => {
//   let dividedAreas: Area[] = [];

//   // Divide horizontally
//   if (areaToDivide.start.ri < areaToSubtract.start.ri) {
//     dividedAreas.push({
//       start: areaToDivide.start,
//       end: { ci: areaToDivide.end.ci, ri: areaToSubtract.start.ri - 1 },
//     });
//   }
//   if (areaToDivide.end.ri > areaToSubtract.end.ri) {
//     dividedAreas.push({
//       start: { ci: areaToDivide.start.ci, ri: areaToSubtract.end.ri + 1 },
//       end: areaToDivide.end,
//     });
//   }

//   // Divide vertically
//   if (areaToDivide.start.ci < areaToSubtract.start.ci) {
//     dividedAreas.push({
//       start: areaToDivide.start,
//       end: { ci: areaToSubtract.start.ci - 1, ri: areaToSubtract.end.ri },
//     });
//   }
//   if (areaToDivide.end.ci > areaToSubtract.end.ci) {
//     dividedAreas.push({
//       start: { ci: areaToSubtract.end.ci + 1, ri: areaToDivide.start.ri },
//       end: areaToDivide.end,
//     });
//   }

//   const getUnHiddenIndex = (index: number, dir: DataDirection, isCol = false) =>
//     getUnHiddenRowCol(
//       isCol ? sheet.cols : sheet.rows,
//       index,
//       0,
//       isCol ? sheet.maxColCount : sheet.maxRowCount,
//       dir,
//       isCol ? sheet.freezedCols : sheet.freezedRows,
//       isCol ? undefined : sheet.filterResult
//     );

//   dividedAreas = dividedAreas.map(({ start, end }) => {
//     start.ci = getUnHiddenIndex(start.ci, DataDirection.Forward, true);
//     end.ci = getUnHiddenIndex(end.ci, DataDirection.Backward, true);

//     start.ri = getUnHiddenIndex(start.ri, DataDirection.Forward);
//     end.ri = getUnHiddenIndex(end.ri, DataDirection.Backward);

//     return { start, end };
//   });
//   return dividedAreas;
// };
// #endregion
